import { IAuthServiceMock } from "@/services";

export const mockAuthService = (): IAuthServiceMock => ({
  getUser: jest.fn(),
  getSignedIn: jest.fn(),
  completeLogin: jest.fn(),
  logout: jest.fn(),
  getIdToken: jest.fn(),
  getLogoutUri: jest.fn(),
});
